import React, { useState, useContext, useEffect } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import SC from '../Vouchers/Account/elements'
import { getConfigFor } from '../../utils/configService'
import useVoucherCodeHook from '../Vouchers/Account/useVoucherTabHook'
import VoucherDetailsPopUp from '../Vouchers/Account/VoucherDetailsPopUp'
import { AccountConsumer } from '../../components/AccountProvider'
import Text from '../../components/Text/Text'
import EmptyIcon from './assets/EmptyVoucher.svg'
import DownloadAppImageDesktopView from './assets/DownloadApp_DesktopView.png'
import DownloadAppImageMobileView from './assets/DownloadApp_MobileView.png'
import QRCodeImage from './assets/voucherpopup_web_qr.png'

import { GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import VirtualCarousel from '../VirtualCarousel/VirtualCarousel'
import SideSheet from '@ntuctech/devex-tangram/SideSheet/SideSheet'
import { SCREEN_SIZE } from '../../lib/Media'
import VoucherCard from './VoucherCard'
import { SPLIT_FEATURES } from '../../utils/constants'
import { capitalizeFirstLetterLowercaseOther } from '../../lib/stringHelperFunctions'
import { TRACKER_CONSTANTS } from '../Vouchers/utils/vouchersTracker'
import tangramNextConfig from '../../lib/tangramNextConfig'
import { Modal, Button, ConfigProvider } from '@ntuctech/tangram-web'
import useMediaQuery from '../../components/DeliveryOrderDetail/hooks/useMediaQuery'
import { trackVoucherViewedEvent } from '../../lib/analytics/events/voucherEvents/VoucherViewEvent'
import { Context } from '../../components/CheckoutAddressProvider'
import { trackSeeAllButtonClickedEvent } from '../../lib/analytics/events/buttonClickEvents/SeeAllButtonClickedEvent'
import {
  BUSINESS_VERTICAL,
  EVENT_CATEGORY,
} from '../../lib/analytics/constants/EventHelper'
import routeController from '../../routes'

const VoucherTitle = styled.div`
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: #333333;
  padding-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const StyledLink = styled(Text)`
  text-decoration: none;
  float: right;
`

const EmptyTitle = styled.div`
  width: 11rem;
  height: 1.5rem;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  display: flex;
  align-items: center;
  color: #333333;
  flex: none;
  order: 0;
  flex-grow: 0;
`

const EmptySubTitle = styled.div`
  width: 11rem;
  height: 2.5rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #696969;
  flex: none;
  order: 1;
  flex-grow: 0;
`

const EmptyContainer = styled.div`
  box-sizing: border-box;
  width: 20.5rem;
  height: 6.25rem;
  left: 1rem;
  background: #ffffff;
  border: 0.063rem solid #eaeaea;
  border-radius: 0.5rem;
  padding: 1rem 0;
`

const VoucherSwimLaneContainer = styled.div`
  margin-bottom: 1rem;
`

const SwimlaneTitle = styled.h2`
  font-weight: 700;
  color: #333333;
  font-size: 1.25rem;
  line-height: 1.4rem;
  ${SCREEN_SIZE.Below.Tablet} {
    font-size: 1rem;
  }
`

const QRImageStyle = styled.img`
  position: absolute;
  width: auto;
  height: 8.25rem;
  top: 2.75rem;
  left: 9rem;
`

const VoucherSwimlaneContainer = ({
  track,
  data,
  isLoggedIn,
  voucherSwimlaneForNonLoggedInFlag,
}) => {
  const [state, dispatch] = useVoucherCodeHook()
  const [voucherData, setVoucherData] = useState([])
  const [openSideSheet, setOpenSideSheet] = useState(false)
  const [showLogInPopup, setShowLogInPopup] = useState(false)
  const { checkoutAddress } = useContext(Context)

  const activeIndex = parseInt(Object.keys(state.activeFilter)[0])
  const FILTER_ERROR = state.filteredData?.length < 1 && activeIndex > 0
  const activeDataList = state.activeData?.list
  const isEmpty = voucherData.length === 0

  const handleLogInPopup = () => {
    if (voucherSwimlaneForNonLoggedInFlag) {
      setShowLogInPopup(!showLogInPopup)
    }
  }

  const handleSegmentVoucherViewedEvent = (item, index, swimlaneTitle) => {
    const match = routeController.match(window.location.href)
    const voucherViewedParams = {
      SCREEN_SECTION: `voucher-collection | ${swimlaneTitle.toLowerCase()}`,
      OFFER_ID: item?.id.toString() || '',
      OFFER_TYPE: item?.offerType || '',
      OFFER_SAP_REFERENCE: null, // not available
      VOUCHER_NAME: item?.detail?.title || '',
      VOUCHER_CODE: item?.code || '',
      VOUCHER_POSITION: index + 1,
      STORE_ID_SAP: checkoutAddress?.clientId || '',
      STORE_ID_DBP: checkoutAddress?.storeId?.toString() || '',
      STORE: checkoutAddress?.storeName || '',
      BUSINESS_VERTICAL:
        match &&
        (match.route?.name === 'product' || match.parsedUrl?.pathname === '/')
          ? BUSINESS_VERTICAL.GROCERY
          : null,
    }
    trackVoucherViewedEvent(voucherViewedParams)
  }

  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])

  useEffect(() => {
    if (state?.activeData?.list?.length > 0 && isEmpty) {
      setVoucherData(
        state.activeData.list.filter(item =>
          item.tags.some(tag => tag === 'Online')
        )
      )
    }

    track({
      [GEV.SCREEN_NAME]: 'Home',
      [GEV.PAGE_TYPE]: 'Home',
      [GEV.CATEGORY]: 'grocery-home-voucher',
      [GEV.EVENT_ACTION]: 'PromotionImpressions',
      [GEV.EVENT_LABEL]: 'Content',
      [GEV.EVENT]: 'hm_push_event',
      [GEV.TRACK]: TRACKER_CONSTANTS.TRACK_PARAM,
    })
  }, [state.activeData.list, track, voucherData, isEmpty])

  useEffect(() => {
    setOpenSideSheet(Object.keys(state.voucherDetails).length > 0)
  }, [state.voucherDetails])

  const isCampaignSaveEveryday =
    typeof window !== 'undefined' &&
    window?.location?.href.endsWith('campaign-save-everyday')

  const currentDate = new Date()
  const isLoggedOutUserAndShowPopup =
    !isLoggedIn && voucherSwimlaneForNonLoggedInFlag
  const isMobile = useMediaQuery(SCREEN_SIZE.Below.Tablet)

  return isMounted ? (
    <VoucherSwimLaneContainer className="myrewards-tab">
      <VoucherTitle>
        <SwimlaneTitle>
          {data?.title
            ? capitalizeFirstLetterLowercaseOther(data.title)
            : 'Vouchers available'}
        </SwimlaneTitle>{' '}
        {voucherData.length > 3 ? (
          isLoggedOutUserAndShowPopup ? (
            <StyledLink
              onClick={handleLogInPopup}
              as="button"
              size="medium"
              color="#1557bf"
              weight="bold"
              data-testid="see-all-og-swimlane"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
              }}
            >
              See all
            </StyledLink>
          ) : (
            <Link
              href={
                isCampaignSaveEveryday
                  ? `/save-everyday-${currentDate.getFullYear()}`
                  : '/accounts?tab=vouchers&filter=Delivery'
              }
              passHref
              prefetch={false}
              legacyBehavior
            >
              <StyledLink
                onClick={() => {
                  localStorage.setItem('isOGVoucher', true)
                  track({
                    [GEV.SCREEN_NAME]: 'Home',
                    [GEV.PAGE_TYPE]: 'Home',
                    [GEV.CATEGORY]: 'Home',
                    [GEV.EVENT_ACTION]: 'PromotionClick',
                    [GEV.EVENT_LABEL]: 'See-all',
                    [GEV.EVENT]: 'hm_push_event',
                    [GEV.TRACK]: TRACKER_CONSTANTS.TRACK_PARAM,
                  })
                  trackSeeAllButtonClickedEvent({
                    SCREEN_SECTION: `voucher-collection | ${data?.title}`,
                    BUSINESS_VERTICAL: null,
                    EVENT_CATEGORY: EVENT_CATEGORY.VOUCHER,
                  })
                }}
                as="a"
                size="medium"
                color="#1557bf"
                weight="bold"
                data-testid="see-all-og-swimlane"
              >
                See all
              </StyledLink>
            </Link>
          )
        ) : (
          ''
        )}
      </VoucherTitle>
      {isEmpty ? (
        <EmptyContainer>
          <SC.EmptyVoucherCardGrid container>
            <SC.Grid item xs={7}>
              <EmptyTitle>Better luck tomorrow!</EmptyTitle>
              <EmptySubTitle>Check back daily for more vouchers</EmptySubTitle>
            </SC.Grid>
            <SC.Grid item xs={4}>
              <img src={EmptyIcon} alt="Empty Voucher" />
            </SC.Grid>
          </SC.EmptyVoucherCardGrid>
        </EmptyContainer>
      ) : (
        <SC.OGVoucherContainer>
          <SC.Grid container className="voucher-container">
            <VirtualCarousel
              items={
                isCampaignSaveEveryday
                  ? voucherData
                      .filter(voucher => voucher.code.startsWith('SEC'))
                      .slice(0, 20)
                  : voucherData
              }
              staticHeight={{
                [SCREEN_SIZE.From.MobileL]: 110,
                [SCREEN_SIZE.Below.MobileL]: 110,
              }}
              staticWidth={{
                [SCREEN_SIZE.From.MobileL]: 366,
                [SCREEN_SIZE.Below.MobileL]: 382,
              }}
            >
              {({ item, index }) => {
                handleSegmentVoucherViewedEvent(item, index, data.title)
                return (
                  <VoucherCard
                    i={index}
                    item={item}
                    error={activeDataList?.length < 1 || FILTER_ERROR}
                    loading={state.loading}
                    dispatch={
                      isLoggedIn
                        ? {
                            ...dispatch,
                            handleViewClick: (
                              clickedItem,
                              clickedIndex,
                              swimlaneTitle
                            ) => {
                              swimlaneTitle =
                                swimlaneTitle ||
                                data?.title ||
                                'Vouchers available'
                              dispatch.handleViewClick(
                                clickedItem,
                                clickedIndex,
                                swimlaneTitle
                              )
                            },
                          }
                        : {
                            handleViewClick: handleLogInPopup,
                            parentDispatch: () => {},
                          }
                    }
                    imgLoading={state.loading}
                    filterValue={state.activeFilter}
                    showFilter={state.showFilter}
                    track={track}
                    isVoucher
                  />
                )
              }}
            </VirtualCarousel>
          </SC.Grid>
        </SC.OGVoucherContainer>
      )}
      <ConfigProvider
        tokens={tangramNextConfig}
        experimental={{
          Modal: true,
          Button: true,
        }}
      >
        <Modal open={showLogInPopup} onOpenChange={handleLogInPopup}>
          {isMobile ? (
            <>
              <Modal.Image src={DownloadAppImageMobileView} />

              <Modal.Title size="m">
                Save with the FairPrice Group app
              </Modal.Title>

              <Modal.Body>
                Download the app and log in to access exclusive vouchers.
              </Modal.Body>

              <Modal.Footer style={{ flexDirection: 'column' }}>
                <Modal.Action>
                  <Button
                    variant="primary"
                    onClick={() => {
                      window.open(
                        'https://go.fpg.sg/webtoapp-mobileweb-button',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }}
                  >
                    Download app
                  </Button>
                </Modal.Action>
                <Modal.Action>
                  <Button variant="text">Close</Button>
                </Modal.Action>
              </Modal.Footer>
            </>
          ) : (
            <>
              <Modal.Image src={DownloadAppImageDesktopView} />
              <QRImageStyle src={QRCodeImage} alt="QR Code" />

              <Modal.Title size="m">Log in to start saving</Modal.Title>

              <Modal.Body>
                Get exclusive vouchers with the FairPrice Group app. Scan the QR
                code to download.
              </Modal.Body>

              <Modal.Footer orientation="horizontal">
                <Modal.Action>
                  <Button variant="primary">Close</Button>
                </Modal.Action>
              </Modal.Footer>
            </>
          )}
        </Modal>
      </ConfigProvider>
      <SideSheet
        data-testid="voucher-sidesheet"
        open={openSideSheet}
        onClose={() => setOpenSideSheet(false)}
        direction="right"
        title="About this voucher"
        size={300}
        enableOverlay
        lockBackgroundScroll
        description=""
      >
        <SC.GlobalStyle openSideSheet={openSideSheet} />
        <VoucherDetailsPopUp
          dispatch={dispatch}
          voucherDetails={state.voucherDetails}
          pastTab={state.activeTab > 0}
          showQrCode={state.showQrCode}
          showHowToUse={state.showHowToUse}
          handleClose={dispatch.onHandleClose}
          imgLoading={state.imgLoading}
          isSideSheet={true}
        />
      </SideSheet>
    </VoucherSwimLaneContainer>
  ) : null
}

const VoucherSwimlane = props => {
  const { isEnabled: voucherSwimlaneForNonLoggedInFlag } = getConfigFor(
    SPLIT_FEATURES.FE_VOUCHER_SWIMLANE_FOR_NON_LOGGED_IN
  )

  return (
    <EventTrackingConsumer>
      {({ track }) => (
        <AccountConsumer>
          {({ isLoggedIn }) =>
            voucherSwimlaneForNonLoggedInFlag || isLoggedIn ? (
              <VoucherSwimlaneContainer
                {...props}
                isLoggedIn={isLoggedIn}
                voucherSwimlaneForNonLoggedInFlag={
                  voucherSwimlaneForNonLoggedInFlag
                }
                track={track}
              />
            ) : null
          }
        </AccountConsumer>
      )}
    </EventTrackingConsumer>
  )
}

export default VoucherSwimlane
